import { Box, makeStyles } from "@material-ui/core";
import { formatNumber } from "App/utils/helpers";
import React from "react";
// import { useEffect } from "react";
// import { ListTotalPembelianFetch } from "./helpers";

const useStyles = makeStyles({
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
});

export default function ListTotalPembelian(data, setData) {
  const classes = useStyles();
  return (
    <Box
      component="div"
      sx={{ padding: "20px 10px", background: "#ffffff", borderRadius: 10 }}>
      <div>
        <table width="100%" className="table-perhitungan-pembelian-wms">
          <tbody>
            <tr>
              <td width="40%">Jumlah Data</td>
              <td width="5%">:</td>
              <td width="55%" align="right">
                {formatNumber(data.data.jmlPembelian)}
              </td>
            </tr>
            <tr>
              <td width="40%">Total Beli</td>
              <td width="5%">:</td>
              <td width="55%" align="right">
                {formatNumber(data.data.totalPembelian)}
              </td>
            </tr>
            <tr>
              <td width="40%">Total Potongan</td>
              <td width="5%">:</td>
              <td width="55%" align="right">
                {formatNumber(data.data.totalPotongan)}
              </td>
            </tr>

            <tr>
              <td colSpan="2"></td>
              <td colSpan="2" className={classes.border}></td>
            </tr>

            <tr>
              <td width="40%">Jumlah Tax</td>
              <td width="5%">:</td>
              <td width="55%" align="right">
                {formatNumber(data.data.totalTax)}
              </td>
            </tr>

            <tr>
              <td colSpan="2"></td>
              <td colSpan="2" className={classes.border}></td>
            </tr>

            <tr>
              <td width="40%">Total Jumlah</td>
              <td width="5%">:</td>
              <td width="55%" align="right">
                {formatNumber(data.data.totalJumlahPembelian)}
              </td>
            </tr>

            <tr>
              <td colSpan="2"></td>
              <td colSpan="2" className={classes.border}></td>
            </tr>

            <tr>
              <td width="40%">Total Cicilan</td>
              <td width="5%">:</td>
              <td width="55%" align="right">
                {formatNumber(data.data.totalBayar)}
              </td>
            </tr>

            <tr>
              <td colSpan="2"></td>
              <td colSpan="2" className={classes.border}></td>
            </tr>

            <tr>
              <td width="40%">Jumlah Hutang</td>
              <td width="5%">:</td>
              <td width="55%" align="right">
                {formatNumber(data.data.totalSisa)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Box>
  );
}
